var exports = {
  "e": "x1cb7f6e3--f2df3a--loan-details",
  "Q": "x1cb7f6e3--f2df3a--text",
};

module.exports = exports;
